import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import XLSX from "xlsx";
import { make_cols } from "./config/MakeColumns";

var ExcelReader = /*#__PURE__*/function () {
  function ExcelReader(file, fileBegins) {
    _classCallCheck(this, ExcelReader);

    this.file = file;
    this.data = {};
    this.cols = [];
    this.fileBegins = fileBegins || 1;
  }

  _createClass(ExcelReader, [{
    key: "readFile",
    value: function () {
      var _readFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  /* Boilerplate to set up FileReader */
                  var reader = new FileReader();
                  var rABS = !!reader.readAsBinaryString; // console.log(this.file);

                  reader.onload = function (e) {
                    /* Parse data */
                    var bstr = e.target.result;
                    var wb = XLSX.read(bstr, {
                      type: rABS ? "binary" : "array",
                      cellDates: true,
                      bookVBA: true
                    });
                    /* Get first worksheet */
                    // ForEach de sheet names para todas las pages

                    for (var index = 0; index < wb.SheetNames.length; index++) {
                      var wsname = wb.SheetNames[index];
                      var ws = wb.Sheets[wsname];
                      /* Convert array of arrays */

                      var dataSheet = XLSX.utils.sheet_to_json(ws);

                      for (var fileToDelete = 0; fileToDelete < _this.fileBegins; fileToDelete++) {
                        dataSheet.shift();
                      }

                      var dataSheetColumns = dataSheet[0]; // console.log("columns", dataSheet[0]);

                      dataSheet.shift(); // console.log("data page", dataSheet);

                      _this.data[wsname] = {};
                      _this.data[wsname].columns = dataSheetColumns;
                      _this.data[wsname].data = dataSheet;
                      _this.cols = make_cols(ws["!ref"]);
                    } // console.log(this.data);


                    resolve(_this.data);
                  };

                  if (rABS) {
                    reader.readAsBinaryString(_this.file);
                  } else {
                    reader.readAsArrayBuffer(_this.file);
                  }
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function readFile() {
        return _readFile.apply(this, arguments);
      }

      return readFile;
    }()
  }]);

  return ExcelReader;
}();

export default ExcelReader;